export default {
      id: "premium-returns-usage",
      viewBox: "0 0 200 60",
      url: __webpack_public_path__ + "sprite.svg#premium-returns",
      toString: function () {
        return this.url;
      }
    }